import Link from '@components/ui/Link'
import styles from './styles.module.scss'
import ButtonMinimal from '@components/ui/Button/ButtonMinimal'
import { useRouter } from 'next/router'
import { prefixLocale } from '@helpers/env'

export function Column({
  children,
  classes = ''
}: {
  children: React.ReactNode
  classes?: string
}) {
  return <div className={`${styles.Column} ${classes}`}>{children}</div>
}

export function ColumnHeader({
  linkText,
  linkUrl,
  title,
  children
}: {
  linkText?: string
  linkUrl?: string | null
  title: string
  children?: React.ReactNode
}) {
  const router = useRouter()
  const handleLinkClick = () => {
    const trimmedLabel = title.replace(/\s/g, '-')?.toLowerCase()
    router.push(
      {
        href: `${prefixLocale()}/account?page=${trimmedLabel}`,
        query: { page: trimmedLabel }
      },
      `${prefixLocale()}/account?page=${trimmedLabel}`,
      {
        scroll: false,
        shallow: true
      }
    )
  }
  return (
    <div className={styles.ColumnHeader}>
      <h4>{title}</h4>
      {children}
      {linkText && !linkUrl && (
        <ButtonMinimal underlined={true} onClick={handleLinkClick}>
          {linkText}
        </ButtonMinimal>
      )}
      {linkUrl && (
        <Link href={linkUrl} rawHref={true}>
          {linkText}
        </Link>
      )}
    </div>
  )
}

export function ColumnContent({ children }: { children: React.ReactNode }) {
  return <div className={styles.ColumnContent}>{children}</div>
}
